"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_infographic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 191.5 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "infographic-hi"), /*#__PURE__*/React.createElement("g", {
    id: "fbbccf7b-4920-46d0-b782-398151bfd1c7",
    "data-name": "infographics-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cb723677-77c8-47e6-8d7f-e40f84d48a3f",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0859bc5e-a8eb-4708-82a1-840ccdcbf7a2",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c9516bba-3b08-402c-a942-2d0497625136",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a89fcf8f-f606-4570-9461-2dc0e70fb903",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "397802a5-30b0-4f60-8f21-600c7b12a16f",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fed93e0b-b6e2-47be-9180-2a69f8677f89",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "86145824-654a-450d-87fa-bb25bfae3659",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e1f46fd5-5313-4b96-a440-798d43360329",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7e681e64-b97f-4b47-bfa8-2e27fb56aa7f",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1f95518d-20b3-4a57-ac46-9ffb15f10083",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb35bcec-7945-4ad2-a85e-fe1137d0ba24",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1b5086c3-9610-46d3-8fdc-15f01b28f294",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9e686ca-0006-4c30-95dd-665ea498c369",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2800f01a-9350-436b-a3ee-894c8611f71c",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "9fad1869-f5df-47bf-9fa8-a6248716fbe8",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l71.24,36.28a79.88,79.88,0,0,1-14.7,20.23L96,96.09",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l56.54,56.5a79.88,79.88,0,0,0,14.7-20.23L96,96.09",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l79.36-9.74a76,76,0,0,1-8.12,46Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09,116.65,18.9c32.46,8.69,54.57,34.11,58.67,67.45Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,96.09l56.54,56.51a79.93,79.93,0,0,1-113.08-113C60.22,18.8,88.25,11.29,116.65,18.9Z",
    transform: "translate(-0.25 -0.25)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.12a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.12Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  })))))))))))))))));
}

var _default = ic_infographic;
exports.default = _default;